/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from "react";
import PLACEHOLDER from "../../images/placeholder.svg";
import { useNavigate } from "react-router-dom";
import * as WorldAction from "@mywvglobal-shared/mywv-shared/action/worldAction";
import { useDispatch, useSelector } from "react-redux";
import ImageCheck from "../atoms/ImageCheck";
import { encrypt } from "../../utilities/tokenizer";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { gaEvent } from "../../utilities/analytics";
import { diffYMDHMS, convertToLocaleDate } from "../../utilities/dateUtilities";
import { useEffect } from "react";
import revealChosenChildCard from "../../images/chosen/single_reveal_child_card.svg";
import singleChosenChildCard from "../../images/chosen/single_chosen_child_card.svg";
import { setEncryptedCookie } from "../../utilities/cookieUtilities";
import CelebrateIcon from "../../images/Project_Celebrate_icon.svg";

const styles = {
  container: {
    cursor: "pointer",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    top: "-41px",
    left: "-50%",
  },
  textcontainer: {
    position: "relative",
    borderRadius: 30,
    display: "flex",
    flexDirection: "column",
    width: "fit-content",
    padding: "6px 20px 8px",
    justifyContent: "center",
    alignItems: "center",
  },
  textcontainerupdate: {
    backgroundColor: "#F66700",
  },
  textcontainernoupdate: {
    backgroundColor: "white",
  },
  iconstyle: {
    width: "62px",
    height: "82px",
    border: "2px solid white",
    alignSelf: "center",
    borderRadius: 2,
    marginBottom: -10,
  },
  iconstylechosen: {
    width: "62px",
    height: "82px",
    alignSelf: "center",
    borderRadius: 2,
    marginBottom: -10,
  },
  iconstylesearch: {
    width: "100px",
    height: "132px",
    border: "2px solid white",
    alignSelf: "center",
    borderRadius: 2,
    marginBottom: -10,
  },
  iconplaceholderstyle: {
    width: "62px",
    height: "82px",
    alignSelf: "center",
    borderRadius: 2,
    marginBottom: -10,
    border: "2px solid white",
    objectFit: "cover",
  },
  iconplaceholdersearchstyle: {
    width: "100px",
    height: "132px",
    border: "2px solid white",
    alignSelf: "center",
    borderRadius: 2,
    marginBottom: -10,
  },
  inputstyle1: {
    color: "black",
    fontFamily: "Lato-Bold",
    fontSize: "14px",
  },
  inputstyle2: {
    color: "black",
    marginTop: 2,
    fontFamily: "Lato",
    fontSize: "12px",
    textAlign: "center",
    width: "140px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    WebkitLineClamp: 2,
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
  },
  inputstyle1update: {
    color: "white",
    fontFamily: "Lato-Bold",
    fontSize: "14px",
  },
  inputstyle2update: {
    color: "white",
    marginTop: 2,
    fontFamily: "Lato",
    fontSize: "12px",
    textAlign: "center",
    width: "140px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    WebkitLineClamp: 2,
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
  },
  circleupdate: {
    position: "absolute",
    minWidth: 28,
    minHeight: 28,
    backgroundColor: "#FF6B00",
    borderRadius: "50%",
    border: "2px solid white",
    top: -14,
    right: -14,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Lato",
    fontWeight: 500,
    color: "#fff",
    fontSize: 14,
    padding: "3%",
    aspectRatio: "1/1"
  },
  iconplacehlderstyle: {
    width: 60,
    height: 60,
    alignSelf: "center",
    marginBottom: -10,
  },
  celebrationIcon: {
    width: "20px",
    height: "20px"
  }
}

export default function SingleChildMarkerView(props) {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { persistItemsReducer } = useSelector((state) => state);
  const [isMomentOfReveal, setIsRevealMoment] = useState(false);
  const [isRevealToday, setIsRevealToday] = useState(false);
  const [showCelebrationIcon, setShowCelebrationIcon] = useState(false);
  useEffect(() => {
    const item = props?.childValue;
    const today = new Date();
    const sponsorDate = new Date(item?.sponsorNotificationDate);
    const endDate = new Date(item?.apEstimatedEndDate);
    const isEligible = item?.isCelebrationEligible === true;
    if (
      sponsorDate.toString() !== "Invalid Date" &&
      endDate.toString() !== "Invalid Date" &&
      today >= sponsorDate &&
      today <= endDate &&
      isEligible
    ) {
      setShowCelebrationIcon(true);
    } else {
      setShowCelebrationIcon(false); 
    }
  }, [props?.childValue]);
  const updateImage =
  showCelebrationIcon ? (
      <div style={styles.circleupdate}>
        <img src={CelebrateIcon} alt="Celebration" style={styles.celebrationIcon} />
      </div>
    ) : props?.childValue?.hasUpdate ? (
      <div style={styles.circleupdate}>{props?.childValue?.numberOfUpdates}</div>
    ) : null;

  const getChildName = () => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    if (Object.keys(props?.childValue).includes("revealDate")) {
      if (isMomentOfReveal) {
        return "Meet your child!";
      }
      if (isRevealToday) {
        return "Reveal: Today!";
      }
      return `Reveal: ${months[new Date(props?.childValue?.revealDate).getMonth()]} ${new Date(props?.childValue?.revealDate).getDate()}`;
    }
    return props?.childValue?.childFirstName;
  };

  const childImage = () => {
    let imgURL = ""
    let searchStyle = styles.iconstylesearch;
    if (props?.childValue?.chosenCorrelationID) {
      imgURL = isMomentOfReveal ? revealChosenChildCard : singleChosenChildCard;
      searchStyle = { ...styles.iconstylesearch, ...{ "border": "none" } };
    } else {
      imgURL = props?.childValue?.childImageURL
    }
    return imgURL ? (
      <ImageCheck
        imageUrl={imgURL}
        style={props?.childSearch == true ? searchStyle : props?.childValue?.chosenCorrelationID ? styles.iconstylechosen : styles.iconstyle}
        placeholderImage={1}
      />
    ) : <img src={PLACEHOLDER} style={props?.childSearch == true ? styles.iconplaceholdersearchstyle : styles.iconplaceholderstyle} alt="" />;
  }

  const handleChildClick = () => {
    if (props?.clickedButton !== "connect" && props?.clickedButton !== "give") {
      if (props?.childValue?.chosenCorrelationID) {
        setEncryptedCookie(
          "currentChild",
          props?.childValue?.chosenCorrelationID
        );
        if (isMomentOfReveal) {
          navigate("/chosen-children/");
        } else {
          navigate(`/chosen-layout/${props?.childValue?.chosenCorrelationID}`);
        }
      } else {
        const param = {
          selectedChildValues: props?.childValue,
        };
        dispatch(WorldAction.saveChildDetails(param));
        navigate(`/communityhomeview/${encrypt(props?.childValue?.childCode)}`);
        gaEvent("SignleChildName", persistItemsReducer);
      }
    }
  };

  useEffect(() => {
    setIsRevealMoment(false);
    setIsRevealToday(false);
    const diffObj = diffYMDHMS(convertToLocaleDate(props?.childValue?.revealDate?.replace("12:00:00 AM", "7:00:00 PM GMT+13")), convertToLocaleDate());
    if (diffObj?.days < 0) {
      setIsRevealMoment(true);
    } else if (diffObj?.days == 0) {
      setIsRevealToday(true)
    }
  }, [props?.childValue?.revealDate])

  return (
    <div
      className="single-child-container"
      style={styles.container}
      onClick={handleChildClick}
    >
      {childImage()}
      <OverlayTrigger placement="top" overlay={<Tooltip>{props?.childValue?.childFirstName} - {props?.childProjectCountry}</Tooltip>}>
        <div
          style={{
            ...styles.textcontainer,
            ...props?.childValue?.hasUpdate || isMomentOfReveal || props?.childValue?.isCelebration
              ? styles.textcontainerupdate
              : styles.textcontainernoupdate,
          }}
        >
          <span
            style={{
              ...styles.inputstyle1,
              ...props?.childValue?.hasUpdate || isMomentOfReveal || props?.childValue?.isCelebration
                ? styles.inputstyle1update
                : styles.inputstyle1,
            }}
          >
            {getChildName()}
          </span>
          <span
            style={{
              ...styles.inputstyle2,
              ...props?.childValue?.hasUpdate || isMomentOfReveal || props?.childValue?.isCelebration
                ? styles.inputstyle2update
                : styles.inputstyle2,
            }}
          >
            {props?.childProjectCountry}
          </span>
          {updateImage}
        </div>
      </OverlayTrigger>
    </div>
  );
}
